module.exports = __webpack_public_path__ + "img/cert-yes.b9b77120.png";